import i18n from 'i18next';

import axios from '@/util/axios';

const optionsTransform = [
  ...axios.defaults.transformResponse,
  (data) => {
    if (data.errors) return data;

    return {
      ...data,
      data: data.data.map((item) => ({ ...item, label: item.name, value: item.id })),
    };
  },
];

const labelTransform = [
  ...axios.defaults.transformResponse,
  (data) => (!data.errors ? data.data.name : data),
];

export default (param) => {
  const config = {
    course_id: {
      getOptionsAxiosConfig: ({ pageParam, searchQuery, extraParams = {} }) => ({
        params: {
          page: pageParam,
          query: searchQuery,
          ...extraParams,
        },
        transformResponse: optionsTransform,
        url: '/api/admin/courses/search',
      }),
      getSelectedLabelAxiosConfig: ({ id }) => ({
        transformResponse: labelTransform,
        url: `/api/admin/courses/${id}/properties`,
      }),
      placeholder: i18n.t('search-courses'),
    },
    group_id: {
      getOptionsAxiosConfig: ({ pageParam, searchQuery }) => ({
        params: { page: pageParam, search: searchQuery },
        transformResponse: optionsTransform,
        url: '/api/admin/groups',
      }),
      getSelectedLabelAxiosConfig: ({ id }) => ({
        transformResponse: labelTransform,
        url: `/api/admin/groups/${id}/info_with_users`,
      }),
      placeholder: i18n.t('search-groups'),
    },
    letter_id: {
      getOptionsAxiosConfig: ({ pageParam, searchQuery }) => ({
        params: { page: pageParam, search: searchQuery },
        transformResponse: optionsTransform,
        url: '/api/admin/letters',
      }),
      getSelectedLabelAxiosConfig: ({ id }) => ({
        transformResponse: labelTransform,
        url: `/api/admin/letters/${id}`,
      }),
      placeholder: i18n.t('search-letters'),
    },
    session_id: {
      getOptionsAxiosConfig: ({ searchQuery }) => ({
        params: { query: searchQuery },
        transformResponse: optionsTransform,
        url: '/api/admin/course_sessions/search',
      }),
      getSelectedLabelAxiosConfig: ({ id }) => ({
        transformResponse: labelTransform,
        url: `/api/admin/course_sessions/${id}/properties`,
      }),
      placeholder: i18n.t('search-courses'),
    },
    user_id: {
      getOptionsAxiosConfig: ({ pageParam, searchQuery }) => ({
        params: { page: pageParam, query: searchQuery },
        transformResponse: optionsTransform,
        url: '/api/admin/users/search',
      }),
      getSelectedLabelAxiosConfig: ({ id }) => ({
        transformResponse: labelTransform,
        url: `/api/admin/users/${id}/details_for_autocomplete`,
      }),
      placeholder: i18n.t('search-users'),
    },
  };

  return config[param] || {};
};
